import { render, staticRenderFns } from "./toolbar-save.vue?vue&type=template&id=e752877c&"
import script from "./toolbar-save.vue?vue&type=script&lang=ts&"
export * from "./toolbar-save.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports